import { observable, action } from 'mobx';
import Den from 'src/models/Den';
import { IApiService } from 'src/services/IApiService';

export default class DenStore {
    @observable public days: Den[] = [];

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadForClient(clientId: number) {
        this.days = [];
        this.api.getKlientDen(clientId).then(a => a.map(den => this.days.push(den)));
    }

    @action
    public createNewDen(clientId: number, date: Date, type: string) {
        const toInsert: Den = new Den();
        toInsert.idKlient = clientId;
        toInsert.datum = date;
        toInsert.typ = type;
        
        this.api.createNewDen(toInsert).then(den => {this.days.push(den)});
    }

    @action
    public deleteDen(den: Den): Promise<Den> {
        return new Promise(resolve => {
          this.api.deleteDen(den)
            .then(turn => {
                const index = this.days.findIndex(a => a.idKlient === turn.idKlient && a.datum === turn.datum);
                if(index >= 0) {
                    this.days.splice(index, 1);
                }
                resolve(turn);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/DenStore.tsx